import { ml } from "./../matrixlib";
import { plugins } from "./PluginManager";
import type { ICategoryGroup, ICategoryGroups } from "../../ProjectSettings";
import { XRSettingType, XRCategoryAndSettingListType } from "../../RestResult";
import { mDHF } from "./PluginManagerDocuments";
import { UIToolsConstants } from "../matrixlib/MatrixLibInterfaces";
import { NavBar } from "../UI/Components";
import { IItem, IStringStringArrayMap, globalMatrix, matrixSession, app } from "../../globals";

export type { IDB, IDBParent, XRCategoryAndSettingListTypeExt };
export { DBCache };

interface ICategoryGroupDB extends ICategoryGroup {
    kids: IDB[];
}

interface IDB {
    children?: IDB[];
    id?: string;
    title?: string;
    type?: string;
    isUnselected?: number;
    background?: string;
    border?: string;
    icon?: string;
    iconClass?: string;
    version?: string;
    extraStyle?: string;
    mode?: string;
    order?: number; // for now used only for dashboards
}
interface IDBParent {
    parent: string;
    position: number;
    item: IItem;
}

interface XRCategoryAndSettingListTypeExt {
    settingList: XRSettingType[];
    categoryId: number | string;
    categoryShort: string;
}

interface IDBCache {
    sortChildren(itemId: string): void;
    initMatrixTree(init: IDB[], includeActivity: boolean): void;
    initConfigTree(init: IDB[]): void;
    getTree(subtreeFilter: string[]): IDB[];
    getParentId(itemId: string): string;
    getCategoryBreadcrumbs(category: string): string[];
    getBreadcrumbs(itemId: string): string[];
    getType(itemId: string): string;
    getIcon(itemId: string): string;
    setStyle(itemIds: string[], style: string, computeFolder: number): void;
    setStyleRec(folder: IDB[], itemIds: string[], style: string, computeFolder: number): boolean;
    isFolder(itemId: string): boolean;
    getItemTitle(itemId: string): string;
    getItemType(itemId: string): string;
    isHiddenLink(itemId: string): boolean;
    setHiddenLink(itemId: string, hidden: number): void;
    hasChildren(itemId: string): boolean;
    doesExist(itemId: string): boolean;
    insertItem(itemJson: IItem, parentId: string): IDBParent;
    copyFrom(target: string, source: IDB): boolean;
    getRootOfType(category: string): string;
    deleteItem(itemId: string): IDB;
    moveItem(itemId: string, newFolder: string, newPosition: number): void;
    updateItem(itemJson: IItem): void;
    getChildrenIds(parentId: string): string[];
    getItemFromCache(itemId: string): IDB;
}

class DBCache implements IDBCache {
    private db: IDB[] = [];
    private activities: IDB[] = [];
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private groupPos: number;
    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
    private groupDefintion: ICategoryGroups;
    private breadCrumbs: IStringStringArrayMap = {};

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    constructor() {}

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected createVirtualFolder(id: string, title: string, icon?: string, color?: string) {
        let folder: IDB = { children: [], iconClass: icon ? icon : "", id: id, title: title, type: "_" + id };
        let cst: XRCategoryAndSettingListTypeExt = {
            settingList: [
                {
                    key: "texticon",
                    value: JSON.stringify({
                        color: color ? color : UIToolsConstants.CIColorsGrey.G3_GreyDark.color,
                        text: id,
                    }),
                    secret: false,
                },
            ],
            categoryId: id,
            categoryShort: "_" + id,
        };
        globalMatrix.ItemConfig.addCategorySetting(<XRCategoryAndSettingListType>cst);
        return folder;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    protected createVirtualItem(order: number, id: string, title: string, icon?: string) {
        let item: IDB = {
            iconClass: icon ? icon : "",
            id: id,
            title: title,
            type: "_" + id,
            order: order,
        };
        return item;
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    sortChildren(itemId: string) {
        let obj: IDB = this.findInDB(this.db, itemId);
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (!obj || !obj.children || obj.children.length == 0) {
            // nothing to sort
            return;
        }

        obj.children.sort(function (a: IDB, b: IDB) {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            return a.title < b.title ? -1 : 1;
        });
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    async initMatrixTree(init: IDB[], includeActivity: boolean) {
        //Wait for all script to be loaded

        let that = this;
        // a cache for breadcrumbs
        this.breadCrumbs = {};

        // create the nodes for the WORK tab
        let myWork: IDB = this.createVirtualFolder("MYWORK", "My Work");

        let dashboards: IDB = this.createVirtualFolder("DASHBOARDS", "Dashboards");

        let tools: IDB = this.createVirtualFolder("TOOLS", "Tools");

        let qms: IDB = this.createVirtualFolder("QMS", "QMS");

        let auditTools: IDB = this.createVirtualFolder("AUDIT", "Audit Tools");

        let connectionTools: IDB = this.createVirtualFolder("ADDONS", "Add Ons");

        let branches: IDB = this.createVirtualFolder("BRANCHES", "Branching");
        let imports: IDB = this.createVirtualFolder("COMPOSE", "Compose");

        let otherTools: IDB = this.createVirtualFolder("OTHER", "Other");
        let drawers = [myWork, auditTools, branches, imports, dashboards, connectionTools, tools, otherTools, qms];

        //
        if (includeActivity) {
            if (!globalMatrix.ItemConfig.getTimeWarp()) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                auditTools.children.push(this.createVirtualItem(2000, "DELETED", "Deleted Items", "fal fa-trash"));
            }
            if (matrixSession.hasAgileSync() && !globalMatrix.ItemConfig.getTimeWarp()) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                connectionTools.children.push(this.createVirtualItem(1000, "SYNC", "Agile Sync", "fal fa-sync-alt"));
            }
            if (app.auditTrailAvailable()) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                auditTools.children.push(this.createVirtualItem(4000, "TAGS", "Tags", "fal fa-tags"));

                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                auditTools.children.push(this.createVirtualItem(1000, "CHANGES", "Changes", "fal fa-calendar-alt"));

                if (matrixSession.hasDocs() && !globalMatrix.ItemConfig.getTimeWarp()) {
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    auditTools.children.push(
                        this.createVirtualItem(5000, "DOCS", "Document Changes and Downloads", "fal fa-file-alt"),
                    );
                }
                if (matrixSession.hasDocs() && !globalMatrix.ItemConfig.getTimeWarp()) {
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    myWork.children.push(
                        this.createVirtualItem(3000, "MYDOCS", "My Signatures", "fal fa-file-signature"),
                    );
                }
            }

            let toolIcons = ["utensil-knife", "shovel-snow", "hammer", "screwdriver", "axe", "shovel", "knife-kitchen"];

            let pages = await plugins.getProjectPages();
            for (let page of pages) {
                // default place for addons = TOOLS
                page.folder = page.folder ? page.folder : "OTHER";
                page.folderTitle = page.folderTitle ? page.folderTitle : "Other Tools";
                let targets = drawers.filter(function (d) {
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    return d.id == page.folder;
                });
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                if (targets.length == 0) {
                    let targetFolder: IDB = that.createVirtualFolder(page.folder, page.folderTitle);
                    drawers.push(targetFolder);
                    targets = [targetFolder];
                }
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                targets[0].children.push(
                    that.createVirtualItem(
                        page.order,
                        page.id,
                        page.title,
                        // TODO: what idx here referring to?
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        page.icon ? page.icon : "fal fa-" + toolIcons[idx % toolIcons.length],
                    ),
                );
            }
        }

        if ((typeof mDHF !== "undefined" || includeActivity) && app) {
            // remove the empty drawers
            drawers = drawers.filter(function (d) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                return d.children.length > 0;
            });
            // sort the items in the drawer
            $.each(drawers, function (dIdx, drawer) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                drawer.children.sort(function (tool1, tool2) {
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    if (tool1.order < tool2.order) {
                        return -1;
                    }
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    if (tool1.order > tool2.order) {
                        return 1;
                    }
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    if (tool1.id < tool2.id) {
                        return -1;
                    }
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    if (tool1.id > tool2.id) {
                        return 1;
                    }
                    return 0;
                });
            });
            // add to navbar
            if (NavBar.isEnabled()) {
                let folderNames: string[] = [];
                $.each(drawers, function (dIdx, drawer) {
                    that.db.push(drawer);
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    folderNames.push(drawer.id);
                });
                NavBar.setWorkFolders(folderNames);
            } else {
                let work: IDB = this.createVirtualFolder("TOOLS", "Tools");
                work.children = drawers;

                // add to project folder
                this.db.push({
                    children: [work],
                    icon: "projectw.png",
                    id: "F-PROJECT",
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    title:
                        mDHF && mDHF.getToolFolderName()
                            ? mDHF.getToolFolderName()
                            : "Project, Reports & Controlled Documents",
                    type: "_PROJECT",
                });
            }
        }

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        this.groupDefintion = globalMatrix.ItemConfig ? globalMatrix.ItemConfig.getCategoryGroupConfig() : null;
        if (this.groupDefintion) {
            $.each(this.groupDefintion.groups, function (gidx: number, group: ICategoryGroupDB) {
                // MATRIX-1557 delete group kids cache
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                group.kids = null;
            });
        }
        this.groupPos = this.db.length; // default pos for groups

        // add all items not in a group
        // TODO: convert to let and make sure it's still works
        // eslint-disable-next-line no-var
        for (var idx = 0; idx < init.length; idx++) {
            if (
                typeof mDHF !== "undefined" &&
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                mDHF.isDocumentType(init[idx].type) &&
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                mDHF.showInProjectFolder(init[idx].type) &&
                !NavBar.isEnabled()
            ) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                this.db[0].children.push(init[idx]);
            } else {
                let inGroup = false;
                if (this.groupDefintion) {
                    // casting group from definition to allow to add kids
                    $.each(this.groupDefintion.groups, function (gidx: number, group: ICategoryGroupDB) {
                        // [{"name":"Design Input", "color":"brown","text":"DI", "categories":["DI1","DI2","DI3","DI3"]}]
                        if (!group.kids) {
                            group.kids = [];
                        }
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        if (group.categories.indexOf(init[idx].type) !== -1) {
                            inGroup = true;
                            group.kids.push(init[idx]);
                        }
                    });
                }
                if (!inGroup) {
                    this.db.push(init[idx]);
                }
            }
        }
        // insert groups
        if (this.groupDefintion) {
            let autoPos = 0; // in case there is no position specified
            // casting group to allow to add DB items
            $.each(this.groupDefintion.groups, function (gidx: number, group: ICategoryGroupDB) {
                //         [{"name":"Design Input", "color":"brown","text":"DI", "categories":["DI1","DI2","DI3","DI3"],"helpPage":"www.matrixreq.com"}]
                let gi: IDB = {
                    children: group.kids,
                    icon: "project.png",
                    id: "F-" + group.text,
                    title: group.name,
                    type: "_" + group.text,
                };
                let position = that.groupPos + (group.position ? group.position : autoPos);
                autoPos++;
                if (position >= that.db.length) {
                    that.db.push(gi);
                } else {
                    that.db.splice(position, 0, gi);
                }
                let cst: XRCategoryAndSettingListTypeExt = {
                    settingList: [
                        {
                            key: "texticon",
                            value: JSON.stringify({
                                color: group.color,
                                text: group.text,
                            }),
                            secret: false,
                        },
                    ],
                    categoryId: "_" + group.text,
                    categoryShort: "_" + group.text,
                };
                globalMatrix.ItemConfig.addCategorySetting(<XRCategoryAndSettingListType>cst);
            });
        }
        plugins.filterProject(this.db);
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    initConfigTree(init: IDB[]) {
        let that = this;

        // add all items not in a group
        for (let idx = 0; idx < init.length; idx++) {
            this.db.push(init[idx]);
        }
    }

    /** getTree returns a tree or a sub tree of the project.
     * this call is synchronous. The database tree is created once during the
     * initialization and filtered after as needed.
     *
     * @param {type} subtreeFilter
     * @returns tree object
     */
    getTree(subtreeFilter: string[]): IDB[] {
        if (typeof subtreeFilter === "undefined" || subtreeFilter.length === 0) {
            return this.db;
        }
        let st: IDB[] = [];
        for (let idx = 0; idx < this.db.length; idx++) {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            if (subtreeFilter.indexOf(this.db[idx].type) !== -1) {
                st.push(this.db[idx]);
            }
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            if (this.db[idx].type[0] === "_") {
                // also look in project filter. There are some 'hidden' trees like REPORT, ECO, CAPA, SIGN...
                // examples of these meta folders are _PROJECT
                let stree = this.db[idx].children;
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                for (let sdx = 0; sdx < stree.length; sdx++) {
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    if (subtreeFilter.indexOf(stree[sdx].type) !== -1) {
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        st.push(stree[sdx]);
                    }
                }
            }
        }

        return st;
    }

    getParentId(itemId: string): string {
        return this.findParentId(this.db, itemId);
    }

    // this is actually really expensive (it's a depth first search, so for category roots we cache the results)
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    getCategoryBreadcrumbs(category: string) {
        if (!this.breadCrumbs[category]) {
            this.breadCrumbs[category] = this.getBreadcrumbs("F-" + category + "-1");
        }
        return this.breadCrumbs[category];
    }

    // this is actually really expensive (it's a depth first search, so for category roots we cache the results)
    getBreadcrumbs(itemId: string): string[] {
        let all = [itemId];
        this.findParentId(this.db, itemId, all);
        return all;
    }

    getType(itemId: string): string {
        let ir = ml.Item.parseRef(itemId);
        if (ir.type !== "") {
            return ir.type;
        }
        // otherwise the id is not a normal id, but something special, like "-1" for "Deleted items... ask the DB
        let obj: IDB = this.findInDB(this.db, itemId);
        if (obj && obj.type) {
            return obj.type;
        }
        // no idea...
        return "";
    }

    getIcon(itemId: string): string {
        let obj: IDB = this.findInDB(this.db, itemId);
        if (obj && obj.icon) {
            return obj.icon;
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return null;
    }

    /* set style of item / folder
        computeFolder: 0=look (folder style from lookup)
        computeFolder: 1=all (all children in folder have style: folder has style)
        computeFolder: 2=any (any of the children has style: folder has style) */
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    setStyle(itemIds: string[], style: string, computeFolder: number) {
        this.setStyleRec(this.db, itemIds, style, computeFolder);
    }
    setStyleRec(folder: IDB[], itemIds: string[], style: string, computeFolder: number): boolean {
        let that = this;
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        let allOrAny = computeFolder == 1 ? true : false;

        $.each(folder, function (idx, idb) {
            if (idb.children) {
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                if (idb.children.length == 0 && computeFolder == 1) {
                    allOrAny = false;
                } else {
                    // a folder
                    let children = that.setStyleRec(idb.children, itemIds, style, computeFolder);
                    let color = false;
                    switch (computeFolder) {
                        case 0:
                            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                            // TODO: MATRIX-7555: lint errors should be fixed for next line
                            // eslint-disable-next-line
                            color = itemIds.indexOf(idb.id) != -1;
                            break;
                        case 1:
                            allOrAny = allOrAny && children;
                            color = children;
                            break;
                        case 2:
                            allOrAny = allOrAny || children;
                            color = children;
                            break;
                    }
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    if (color && (idb.children.length || computeFolder == 0)) {
                        idb.extraStyle = style;
                    }
                }
            } else {
                // an item
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                // TODO: MATRIX-7555: lint errors should be fixed for next line
                // eslint-disable-next-line
                if (itemIds.indexOf(idb.id) != -1) {
                    idb.extraStyle = style;
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                    if (computeFolder == 2) {
                        allOrAny = true;
                    }
                    // TODO: MATRIX-7555: lint errors should be fixed for next line
                    // eslint-disable-next-line
                } else if (computeFolder == 1) {
                    allOrAny = false;
                }
            }
        });

        return allOrAny;
    }
    //MATRIX-7920 : A folder always start with F-
    isFolder(itemId: string): boolean {
        // MATRIX-
        return itemId.startsWith("F-");
    }

    getItemTitle(itemId: string): string {
        let obj = this.findInDB(this.db, itemId);
        if (!obj) {
            return globalMatrix.ITEM_DOES_NOT_EXIST;
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return obj.title;
    }
    getItemType(itemId: string): string {
        let obj = this.findInDB(this.db, itemId);
        if (!obj) {
            return globalMatrix.ITEM_DOES_NOT_EXIST;
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return obj.type;
    }
    isHiddenLink(itemId: string): boolean {
        let obj = this.findInDB(this.db, itemId);
        if (!obj) {
            return true;
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return obj.isUnselected && obj.isUnselected === 1;
    }

    setHiddenLink(itemId: string, hidden: number): void {
        let obj = this.findInDB(this.db, itemId);
        if (obj) {
            obj.isUnselected = hidden;
        }
    }

    hasChildren(itemId: string): boolean {
        let children = this.findInDB(this.db, itemId).children;
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return children && children.length > 0;
    }

    doesExist(itemId: string): boolean {
        let obj = this.findInDB(this.db, itemId);
        return obj ? true : false;
    }

    insertItem(itemJson: IItem, parentId: string): IDBParent {
        if (typeof parentId !== "undefined") {
            let parent = this.findInDB(this.db, parentId);
            if (!itemJson.type) {
                itemJson.type = parent.type;
            }
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            parent.children.push(<IDB>itemJson);

            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            return { parent: parentId, position: parent.children.length - 1, item: itemJson };
        }
        for (let idx = 0; idx < this.db.length; idx++) {
            if (this.db[idx].type === itemJson.type) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                this.db[idx].children.push(<IDB>itemJson);
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                return { parent: this.db[idx].id, position: this.db[idx].children.length - 1, item: itemJson };
            }
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return null;
    }

    // replaces the target, a child inside the target or creates a new child with source
    copyFrom(target: string, source: IDB): boolean {
        let parent = this.findInDB(this.db, target);
        // check if other tree already exists... if so replace it
        if (!parent) {
            ml.Logger.log("error", "cannot find parent folder in tree replacement.");
            return false;
        }
        if (parent.id === source.id) {
            this.internalReplace(parent, source);
            return true;
        }
        if (!parent.children) {
            ml.Logger.log("error", "parent is not a folder.");
            return false;
        }
        for (let idx = 0; idx < parent.children.length; idx++) {
            if (parent.children[idx].id === source.id) {
                // replace child
                this.internalReplace(parent.children[idx], source);
                return true;
            }
        }
        // create a new child and replace
        let newChild: IDB = { id: source.id, title: "", type: "" };
        parent.children.push(newChild);
        this.internalReplace(newChild, source);
        return true;
    }

    getRootOfType(category: string): string {
        let groups: string[] = [];
        let gdef: ICategoryGroups = globalMatrix.ItemConfig.getCategoryGroupConfig();
        if (gdef) {
            $.each(gdef.groups, function (gi, g) {
                groups.push("_" + g.text);
            });
        }
        for (let idx = 0; idx < this.db.length; idx++) {
            if (this.db[idx].type === category) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                return this.db[idx].id;
            }
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            if (groups.indexOf(this.db[idx].type) !== -1) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                for (let j = 0; j < this.db[idx].children.length; j++) {
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    if (this.db[idx].children[j].type === category) {
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        return this.db[idx].children[j].id;
                    }
                }
            }
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return null;
    }

    deleteItem(itemId: string): IDB {
        return this.deleteItemRec(this.db, itemId);
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    moveItem(itemId: string, newFolder: string, newPosition: number) {
        let item = this.findInDB(this.db, itemId);
        if (item) {
            this.deleteItemRec(this.db, itemId);
            this.insertAtRec(this.db, newFolder, newPosition, item);
        }
    }

    updateItem(itemJson: IItem): void {
        // TODO: MATRIX-7555: lint errors should be fixed for next line
        // eslint-disable-next-line
        if (typeof itemJson.title == "undefined") {
            // can happen if item is only partially udpated (lables or some fields only)
            return;
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        let item = this.findInDB(this.db, itemJson.id);
        if (item) {
            item.title = itemJson.title;
        }
    }

    getChildrenIds(parentId: string): string[] {
        let ids: string[] = [];
        let parent = this.findInDB(this.db, parentId);
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        for (let idx = 0; idx < parent.children.length; idx++) {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            ids.push(parent.children[idx].id);
        }
        return ids;
    }

    getItemFromCache(itemId: string): IDB {
        return this.findInDB(this.db, itemId);
    }

    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private internalReplace(newItem: IDB, oldItem: IDB) {
        if (newItem.children !== undefined) {
            newItem.children = oldItem.children;
        }

        newItem.icon = oldItem.icon;
        newItem.isUnselected = oldItem.isUnselected;
        newItem.title = oldItem.title;
        newItem.type = oldItem.type;
    }

    private findInChildren(node: IDB, itemId: string): IDB {
        if (typeof node.children === "undefined") {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            return null;
        }
        for (let child = 0; child < node.children.length; child++) {
            let res = this.findInDB(node.children[child], itemId);
            if (res !== null) {
                return res;
            }
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return null;
    }

    private findInDB(tree: IDB[], itemId: string): IDB;
    private findInDB(tree: IDB, itemId: string): IDB;
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private findInDB(tree: any, itemId: string): IDB {
        if ((<IDB>tree).id === itemId) {
            return tree;
        }
        let res = this.findInChildren(tree, itemId);
        if (res) {
            return res;
        }
        for (let idx = 0; idx < (<IDB[]>tree).length; idx++) {
            if ((<IDB[]>tree)[idx].id === itemId) {
                return tree[idx];
            }
            res = this.findInChildren(tree[idx], itemId);
            if (res) {
                return res;
            }
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return null;
    }

    // get the parent of an item or all parents if all is passed
    private findParentId(tree: IDB, itemId: string, all?: string[]): string;
    private findParentId(tree: IDB[], itemId: string, all?: string[]): string;
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private findParentId(tree: any, itemId: string, all?: string[]): string {
        if ((<IDB>tree).id === itemId) {
            // in case it is a leaf
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            return null; // should have found parent!
        }
        if ((<IDB>tree).children) {
            // in case it is a folder
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            for (let idx = 0; idx < (<IDB>tree).children.length; idx++) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                if ((<IDB>tree).children[idx].id === itemId) {
                    if (all) {
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        all.push((<IDB>tree).id);
                    }
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    return (<IDB>tree).id;
                }
                // maybe it is a child of it's children
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                const res = this.findParentId((<IDB>tree).children[idx], itemId, all);
                if (res) {
                    if (all) {
                        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                        all.push((<IDB>tree).id);
                    }
                    return res;
                }
            }
        }
        if ((<IDB[]>tree).length) {
            // in case it is a collection of folders
            for (let idx = 0; idx < (<IDB[]>tree).length; idx++) {
                if ((<IDB[]>tree)[idx].id === itemId) {
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    return null;
                }
                const res = this.findParentId((<IDB[]>tree)[idx], itemId, all);
                if (res) {
                    return res;
                }
            }
        }
        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return null;
    }

    private deleteItemRec(tree: IDB, itemId: string): IDB;
    private deleteItemRec(tree: IDB[], itemId: string): IDB;
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private deleteItemRec(tree: any, itemId: string): IDB {
        if (typeof (<IDB>tree).children !== "undefined") {
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            for (let idx = 0; idx < (<IDB>tree).children.length; idx++) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                if ((<IDB>tree).children[idx].id === itemId) {
                    // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                    (<IDB>tree).children.splice(idx, 1);
                    return tree;
                }
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                const res = this.deleteItemRec((<IDB>tree).children[idx], itemId);
                if (res) {
                    return res;
                }
            }
        } else if (typeof (<IDB[]>tree).length !== "undefined") {
            for (let idx = 0; idx < (<IDB[]>tree).length; idx++) {
                const res = this.deleteItemRec(tree[idx], itemId);
                if (res) {
                    return res;
                }
            }
        }

        // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
        return null;
    }

    private insertAtRec(tree: IDB, newFolder: string, newPosition: number, item: IDB): boolean;
    private insertAtRec(tree: IDB[], newFolder: string, newPosition: number, item: IDB): boolean;
    // TODO: MATRIX-7555: lint errors should be fixed for next line
    // eslint-disable-next-line
    private insertAtRec(tree: any, newFolder: string, newPosition: number, item: IDB): boolean {
        //moveDetails:
        // "parentId":sourceNode.parent.key,
        // "index":sourceNode.getIndex()
        if ((<IDB>tree).id === newFolder) {
            if (typeof (<IDB>tree).children !== "undefined") {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                (<IDB>tree).children.splice(newPosition, 0, item);
                return true;
            } else {
                // something went wrong...
                return false;
            }
        } else if (typeof (<IDB>tree).children !== "undefined") {
            // this is a folder
            // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
            for (let idx = 0; idx < (<IDB>tree).children.length; idx++) {
                // @ts-ignore TODO: MATRIX-6934: nullStrictCheck should be fixed for next line
                const res = this.insertAtRec((<IDB>tree).children[idx], newFolder, newPosition, item);
                if (res) {
                    return res;
                }
            }
            return false;
        } else if (typeof (<IDB[]>tree).length !== "undefined") {
            for (let idx = 0; idx < (<IDB[]>tree).length; idx++) {
                const res = this.insertAtRec(tree[idx], newFolder, newPosition, item);
                if (res) {
                    return res;
                }
            }
            return false;
        }
        return false;
    }
}
